import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./root-state.interface";

type ApiMode = "BASE" | "TEST";

interface ConfigState {
  apiMode: ApiMode;
  apiVersion: number; // увеличиваем при смене URL, чтобы страницы могли отреагировать
}

const LS_KEY = "apiMode";

const initialMode: ApiMode =
  (localStorage.getItem(LS_KEY) as ApiMode) || "TEST";

const initialState: ConfigState = {
  apiMode: initialMode,
  apiVersion: 0,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setApiMode(state, action: PayloadAction<ApiMode>) {
      state.apiMode = action.payload;
      state.apiVersion += 1;
      localStorage.setItem(LS_KEY, action.payload);
    },
  },
});

export const CONFIG_SLICE_KEY = configSlice.name;
export const { setApiMode } = configSlice.actions;
export const configReducer = configSlice.reducer;

export const selectApiMode = (s: RootState) =>
  (s as any)[CONFIG_SLICE_KEY].apiMode as ApiMode;
export const selectApiVersion = (s: RootState) =>
  (s as any)[CONFIG_SLICE_KEY].apiVersion as number;
